export class TimestampMessages {
  public certificateCertification = 'timestamp.certificate.certification';
  public certificateDate = 'timestamp.certificate.date';
  public certificateLevel = 'timestamp.certificate.level';
  public certificateOid = 'timestamp.certificate.oid';
  public certificateStatus = 'timestamp.certificate.status';
  public certificateSupportType = 'timestamp.certificate.support_type';
  public certificateTitle = 'timestamp.certificate.title';
  public certificateUsage = 'timestamp.certificate.usage';
  public certificateValidity = 'timestamp.certificate.validity';

  public horodatageDate = 'timestamp.horodatage.date';
  public horodatageIdentifier = 'timestamp.horodatage.identifier';
  public horodatageIntegrity = 'timestamp.horodatage.integrity';
  public horodatageTitle = 'timestamp.horodatage.title';
  public horodatageSecurityLevel = 'timestamp.horodatage.security_level';

  public timestampCertification = 'timestamp.timestamp.certification';
  public timestampDate = 'timestamp.timestamp.date';
  public timestampDateTS = 'timestamp.timestamp.date_TS';
  public timestampIdentifier = 'timestamp.timestamp.identifier';
  public timestampIntegrity = 'timestamp.timestamp.integrity';
  public timestampLevel = 'timestamp.timestamp.level';
  public timestampOid = 'timestamp.timestamp.oid';
  public timestampSecurityLevel = 'timestamp.timestamp.securityLevel';
  public timestampSignatory = 'timestamp.timestamp.signatory';
  public timestampStatus = 'timestamp.timestamp.status';
  public timestampSupportType = 'timestamp.timestamp.support_type';
  public timestampTimeTS = 'timestamp.timestamp.time_TS';
  public timestampTitle = 'timestamp.timestamp.title';
  public timestampTitleCertificate = 'timestamp.timestamp.title_certificate';
  public timestampTransmitter = 'timestamp.timestamp.transmitter';
  public timestampUsage = 'timestamp.timestamp.usage';
  public timestampValidity = 'timestamp.timestamp.validity';

  constructor() {
  }
}
